/**
 * Các bước hướng dẫn trên từng loại màn hình
 * @author NVLAM 20.02.2020
 */
export default {
  Common: {
    GuideTitle: "Hướng dẫn",
    ExecuteSeries: "Thực hiện hàng loạt",
    CustomLayout: "Tùy chỉnh giao diện",
    Function: "Chức năng",
    ChooseBussiness: "Chọn nghiệp vụ",
    EnterTheAmount: "Nhập số tiền",
    EnterTheUnitPrice: "Nhập đơn giá",
    EnterTheQuantity: "Nhập số lượng",
    AddRow: "Thêm dòng",
    ChooseObject: "Chọn đối tượng",
    Ultility: "Tiện ích",
    Print: "In chứng từ",
    ChooseInventory: "Chọn hàng hóa, dịch vụ",
    ChooseProduct: "Chọn mặt hàng",
    AddMoreProduct: "Thêm nhiều mặt hàng",
    EnterContractValue: "Nhập giá tri hợp đồng",
    WatchHelp: "Xem hướng dẫn",
    EndTour: "Bắt đầu",
    NextStep: "Tiếp theo",
    PreviousStep: "Quay lại",
    WatchTourGuide: "Xem hướng dẫn",
    TourGuideDescription: "Hướng dẫn từng bước lập chứng từ",
    TourGuideSuggestion: "Lời khuyên",
  },
  Asset: {
    guid1: "Chỉnh sửa và khai báo danh sách Nhóm tài sản, Loại tài sản.",
    guid2:
      "Bạn có thể khai báo thêm, ghi tăng tài sản hoặc Nhập khẩu toàn bộ danh sách tài sản tại đây.",
    guid3:
      "Lựa chọn giao diện danh sách tài sản phù hợp với bạn nhất để thuận tiện trọng quá trình tác nghiệp.",
  },
};
